import { ComponentProps, useCallback } from 'react';

import get from 'lodash/get';

import SearchFilter from './search-filter';
import SelectFilter from './select-filter';

export type FilterOptions = ComponentProps<typeof SelectFilter>['options'];
interface FilterProps {
  accessor: string;
  filterType?: 'search' | 'select';
  appliedFilters?: Record<string, string | boolean>;
  onApplyFilter?: (accessor: string, value: string) => void;
  onClearFilter?: (accessor: string) => void;

  label?: string;
  options?: FilterOptions;
}

const Filters = ({
  filterType,
  accessor,
  label,
  options,
  appliedFilters,
  onApplyFilter,
  onClearFilter,
}: FilterProps) => {
  const clearFilter = useCallback(() => {
    onClearFilter?.(accessor);
  }, [accessor, onClearFilter]);

  const applyFilter = useCallback(
    (value: string) => {
      onApplyFilter?.(accessor, value);
    },
    [accessor, onApplyFilter]
  );

  if (filterType === 'search') {
    const initialValue = get(appliedFilters, accessor, '') as string;
    return (
      <SearchFilter
        label={label}
        initialValue={initialValue}
        onApplyFilter={applyFilter}
        onClearFilter={clearFilter}
      />
    );
  } else if (filterType === 'select') {
    const initialValue = get(appliedFilters, accessor, '') as string;
    return (
      <SelectFilter
        initialValue={initialValue}
        onApplyFilter={applyFilter}
        onClearFilter={clearFilter}
        options={options}
      />
    );
  }
  return null;
};

export default Filters;
